export default {
  label: 'Width',
};
